import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Button, Card, Icon, Modal } from 'antd'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { loadContratos, loadContrato, resetContratoForm } from '../../redux-flow/actions/contratos';
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import FormEndereco from './FormEndereco'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import CardUserWrapper from './CardUserWrapper'
import './minhaConta.css'
import CookieConsentComponent from '../../Components/CookieConsent'
import InsideMenu from '../../Components/InsideMenu'

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

class MinhaConta extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            contratoSelected: 0,
            modalSenhaOpened: false,
            modalEnderecoOpened: false,
            fillBackground: false,
            show: true
        }
    }

    componentDidMount() {
        const { onLoad, userid } = this.props
        if (onLoad && userid) {
            onLoad(this.props.userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    handleClick = (index, id) => () => {
        this.setState({
            contratoSelected: index
        }, () => {
            this.props.onSelectContrato(id)
        })
    }

    openModalSenha = () => {
        this.setState({
            modalSenhaOpened: true
        })
    }
    openModalEndereco = () => {
        this.setState({
            modalEnderecoOpened: true
        })
    }

    closeModalSenha = () => {
        this.setState({
            modalSenhaOpened: false
        })
    }

    closeModalEndereco = () => {
        this.setState({
            modalEnderecoOpened: false
        })
        window.location.reload()
    }

    handleDismiss = () => {
        this.setState({
            show: false
        })
    }

    render() {
        const {
            logged,
            userLogged,
            userLoading,
        } = this.props
        
        return (

            <>
                <Navbar loggedArea={true} />
                {!logged ? <Redirect to="/login" /> : (
                    <div>
                        <div className="section minhaContaWrapper">
                            <Container>
                                <Row>
                                    <Col md={12} className="p-0">
                                        <InsideMenu />   
                                        {!userLoading && userLogged.cep === null && this.state.show &&
                                            <div class="alert alert-danger alert-dismissible fade show notificacao-status" role="alert">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.handleDismiss}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <p className="mb-0"><span onClick={this.openModalEndereco}>Clique aqui</span> para atualizar seu endereço.</p>
                                            </div>
                                        }                                     
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className="section insideSec meusDados">
                            <Container>
                                <Row>
                                    <Col md={12} className="p-0">
                                    <Card>
                                        {userLoading ? <LoadingComponent /> : <CardUserWrapper user={userLogged} />}
                                    </Card>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                )}
                <CookieConsentComponent />
                <Modal
                    title="Preencher endereço"
                    visible={this.state.modalEnderecoOpened}
                    onCancel={this.closeModalEndereco}
                    footer={[
                        <Button key="cancel" onClick={this.closeModalEndereco}>Fechar</Button>
                    ]}
                >
                    <FormEndereco user={userLogged} />
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLoading: state.users.isLoading,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(MinhaConta)